<!--
 * @Descripttion: 说明
 * @Author: 聂章帅
 * @Date: 2023-08-16 08:53:31
 * @LastEditors: 聂章帅
 * @LastEditTime: 2023-09-09 11:07:00
-->
<template>
  <div class="root">
    <div class="searchDiv">
      <div class="searchmodel">
        <el-input
          v-model="keyword"
          @keyup.enter.native="getList"
          placeholder="请输入关键字搜索"
        >
          <i
            slot="suffix"
            class="el-input__icon el-icon-search"
            @click="getList"
          ></i>
        </el-input>
      </div>
    </div>
    <!-- <span>资产招商</span> -->
    <div>
      <XYJingMu
        v-if="cityDetail.cityName == '信阳市'"
        :xiangmuList="zhaoshangList"
      ></XYJingMu>
      <jing-mu v-else :xiangmuList="zhaoshangList"></jing-mu>
    </div>

    <div class="fenye">
      <el-pagination
        prev-text="上一页"
        next-text="下一页"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-size="pagesize"
        :current-page="currentPage"
        layout="prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import JingMu from '../components/Home/JingMu.vue'
import XYJingMu from '../components/Home/XYJingMu.vue'
import { getTenderList } from '../api/资产招商'
import { cityDetail } from '../util/mainOption'

export default {
  components: {
    JingMu,
    XYJingMu,
  },
  data () {
    return {
      zhaoshangList: [],
      pagesize: 9,
      total: 0,
      currentPage: 1,
      keyword: '',
    }
  },
  created () {
    // this.initMethods()
    this.getList()
  },
  methods: {
    // initMethods() {
    //     let dm = sessionStorage.getItem('xiandm') ? sessionStorage.getItem('xiandm') : ''
    //     let jiekoudata = this.ajax_url1('invest/invest_list', this.currentpage, this.pagesize, dm).data
    //     this.zhaoshangList = jiekoudata.list
    //     this.total = jiekoudata.total
    //     console.log(this.zhaoshangList);
    // },
    async getList () {
      let data = {
        pageNum: this.currentPage,
        pageSize: this.pagesize,
        keyword: this.keyword,
        searchValue: this.keyword,
      }
      await getTenderList(data).then((res) => {
        // console.log('资产招商', res)
        this.zhaoshangList = res.data.rows
        this.total = res.data.total
      })
    },
    // 当前每夜多少条
    handleSizeChange (size) {
      this.pagesize = size
      // this.initMethods()
    },
    // 当前页数
    handleCurrentChange (currentpage) {
      this.currentpage = currentpage
      // this.initMethods()
    },
  },
}
</script>

<style scoped>
.root {
  width: 1824px;
  margin: 0 auto;
  min-height: 810px;
  background-color: #fff;
  /* border: 1px solid red; */
  padding: 10px;
  box-shadow: 0px 0px 24px rgba(21, 21, 21, 0.1);
}

.fenye {
  width: 100%;
  /* border: 1px solid red; */
  text-align: center;
  margin-top: 20px;
}

.searchmodel /deep/.el-input {
  font-size: 22px;
  /* border: 1px solid red; */
  text-align: left;
}

.searchmodel /deep/.el-input__inner {
  height: 50px;
  width: 300px;
  border: 1px solid #747474;
  border-radius: 10px;
  /* font-size: 16px; */
}

.searchmodel {
  /* margin-left: 500px; */
  width: 300px;
  padding: 0 10px;
}
</style>
